export const ContractsColumns = [
    {
        name: '№ Договора',
        key: 'number',
    },
    {
        name: 'Файл',
        key: 'original_name',
        withHint: true,
    },
    {
        name: 'Компания',
        key: 'custom_company_name',
        withHint: true,
    },
    {
        name: 'БИН',
        key: 'bin',
    },
    {
        name: 'Подразделение',
        key: 'subdivision_name',
        withHint: true,
    },
    {
        name: 'Дата заключения',
        key: 'date',
    },
    {
        name: 'Дата окончания',
        key: 'expiration_date',
    },
    {
        name: 'Дата загрузки документа',
        key: 'createdAt',
    },
    {
        name: 'Наличие документа',
        key: 'documents',
    },
    {
        name: 'Пролонгация',
        key: 'prolongation',
    },
    {
        name: 'Тип',
        key: 'type',
    },
    {
        name: 'Услуги',
        key: 'services',
    },
    {
        name: 'Кто загрузил',
        key: 'initiator_email',
    },
    {
        name: 'Статус',
        key: 'status',
    },
]

export const ArchiveContractsColumns = [
    {
        name: '№ Договора',
        key: 'number',
    },
    {
        name: 'Файл',
        key: 'original_name',
        withHint: true,
    },
    {
        name: 'Компания',
        key: 'custom_company_name',
        withHint: true,
    },
    {
        name: 'БИН',
        key: 'bin',
    },
    {
        name: 'Подразделение',
        key: 'subdivision_name',
        withHint: true,
    },
    {
        name: 'Дата заключения',
        key: 'date',
    },
    {
        name: 'Дата окончания',
        key: 'expiration_date',
    },
    {
        name: 'Дата загрузки документа',
        key: 'createdAt',
    },
    {
        name: 'Наличие документа',
        key: 'documents',
    },
    {
        name: 'Пролонгация',
        key: 'prolongation',
    },
    {
        name: 'Тип',
        key: 'type',
    },
    {
        name: 'Кто загрузил',
        key: 'initiator_email',
    },
    {
        name: 'Статус',
        key: 'status',
    },
]

export const ContractsRegisterColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Планируемая дата договора',
        key: 'date',
    },
    {
        name: 'Номер договора в реестре',
        key: 'number',
    },
    {
        name: 'Подразделение',
        key: 'subdivisionName',
    },
    {
        name: 'Компания',
        key: 'companyName',
    },
    {
        name: 'БИН',
        key: 'companyBin',
    },
    {
        name: 'Тип договора',
        key: 'type',
    },
    {
        name: 'Статус',
        key: 'status',
    },
    {
        name: 'Инициатор',
        key: 'initiatorEmail',
    },
    {
        name: 'Дата добавления записи',
        key: 'createdAt',
    },
    {
        name: 'Кто добавил запись',
        key: 'createdByEmail',
    },
]

export const ContractsItemColumns = [
    {
        name: 'Номер договора',
        key: 'number',
    },
    {
        name: 'Название',
        key: 'name',
    },
    {
        name: 'Подразделение',
        key: 'subdivision_name',
    },
    {
        name: 'Тип',
        key: 'type',
    },
    {
        name: 'Услуги',
        key: 'services',
    },
    {
        name: 'Кто загрузил',
        key: 'initiator_email',
    },
    {
        name: 'Дата заключения',
        key: 'date',
    },
    {
        name: 'Дата окончания',
        key: 'expiration_date',
    },
    {
        name: 'Дата загрузки документа',
        key: 'createdAt',
    },
    {
        name: 'Пролонгация',
        key: 'prolongation',
    },
]

export const ContractsDocumentsColumns = [
    {
        name: 'Номер приложения',
        key: 'number',
    },
    {
        name: 'Тип',
        key: 'type',
    },
    {
        name: 'Кто загрузил',
        key: 'initiator_email',
    },
    {
        name: 'Дата заключения',
        key: 'date',
    },
    {
        name: 'Дата окончания',
        key: 'expirationDate',
    },
    {
        name: 'Дата загрузки документа',
        key: 'createdAt',
    },
]

export const ContractsStatusColors = {
    1: 'green',
    2: 'red',
}
